import { Box } from '@mantine/core'
import React from 'react'
import {
  FilterCollapsibleHierarchicalMenu,
  FilterCollapsibleList,
  FilterCollapsibleDateRange,
  FilterCollapsiblePriceRange,
  FilterCollapsibleToggle,
} from 'components/InstantSearch'

export const ExpertsFilter = () => (
  <Box>
    <FilterCollapsibleToggle
      attribute="isTopExpert"
      title="Top Experts"
      label="Show only Top Experts"
      on="true"
    />

    <FilterCollapsibleHierarchicalMenu
      attributes={['regions.lvl0', 'regions.lvl1']}
      title="Region"
    />
    <FilterCollapsibleList title="Style" attribute="styles" />
    <FilterCollapsibleList
      title="Consultation length"
      attribute="consultations.lengthInMinutes"
      suffix=" minutes"
    />
    <FilterCollapsiblePriceRange
      title="Price"
      attribute="consultations.price"
    />
    <FilterCollapsibleDateRange
      title="Availability"
      attribute="consultations.middleOfSlotUtcTimestamps"
    />
  </Box>
)
